/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface MovementOnFundsReportFundOperationDtoFinancialPlan
 */
export interface MovementOnFundsReportFundOperationDtoFinancialPlan {
  /**
   *
   * @type {string}
   * @memberof MovementOnFundsReportFundOperationDtoFinancialPlan
   */
  id: string;
  /**
   *
   * @type {number}
   * @memberof MovementOnFundsReportFundOperationDtoFinancialPlan
   */
  number: number;
  /**
   *
   * @type {Date}
   * @memberof MovementOnFundsReportFundOperationDtoFinancialPlan
   */
  createdAt: Date;
  /**
   *
   * @type {Date}
   * @memberof MovementOnFundsReportFundOperationDtoFinancialPlan
   */
  from: Date;
  /**
   *
   * @type {Date}
   * @memberof MovementOnFundsReportFundOperationDtoFinancialPlan
   */
  to: Date;
  /**
   *
   * @type {number}
   * @memberof MovementOnFundsReportFundOperationDtoFinancialPlan
   */
  month: number;
  /**
   *
   * @type {number}
   * @memberof MovementOnFundsReportFundOperationDtoFinancialPlan
   */
  year: number;
}

export function MovementOnFundsReportFundOperationDtoFinancialPlanFromJSON(
  json: any
): MovementOnFundsReportFundOperationDtoFinancialPlan {
  return MovementOnFundsReportFundOperationDtoFinancialPlanFromJSONTyped(json, false);
}

export function MovementOnFundsReportFundOperationDtoFinancialPlanFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MovementOnFundsReportFundOperationDtoFinancialPlan {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    number: json["number"],
    createdAt: new Date(json["createdAt"]),
    from: new Date(json["from"]),
    to: new Date(json["to"]),
    month: json["month"],
    year: json["year"],
  };
}

export function MovementOnFundsReportFundOperationDtoFinancialPlanToJSON(
  value?: MovementOnFundsReportFundOperationDtoFinancialPlan | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    number: value.number,
    createdAt: value.createdAt.toISOString(),
    from: value.from.toISOString(),
    to: value.to.toISOString(),
    month: value.month,
    year: value.year,
  };
}
